// Module
var code = `<div class="testimonios"
    id="testimonios">
    <div class="container">

        <h2 class="testimonios__title">
            {{\$ctrl.testimonios.title}}
        </h2>



    </div>

    <div class="container container--large">
        <div class="testimonios__box">

            <div class="testimonios__list testimonio__owl owl-carousel">


                <article class="testimonios__slide"
                    ng-repeat="item in \$ctrl.testimonios.items track by \$index"
                    ng-class="{'testimonios__slide--par': \$index % 2 === 1}">


                    <img class="testimonios__cita"
                        ng-src="{{\$index % 2 === 0 ? \$ctrl.citaImpar : \$ctrl.citaPar}}"
                        alt="Cita">

                    <div class="testimonios__comentario"
                        ng-bind-html="item.comentario">
                    </div>

                    <p class="testimonios__autor">
                        {{item.autor}}
                    </p>

                </article>

            </div>

        </div>
    </div>
</div>`;
// Exports
export default code;